/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

export const checkIsValid = (fieldType, isInvalid, error) => {
    if (isInvalid) {
        return {
            type: types.SET_VALIDATION_ERROR,
            payload: {
                path: fieldType,
                error,
            },
        };
    }
    return { type: types.SET_VALIDATION_ERROR, payload: { path: fieldType } };
};
